import axios, { API_BASE, handler } from './http-service';
import { MediaPosition, UploadListener } from '../components/interfaces';

export interface CreateData {
  name: string;
  description: string;
  user: string;
  parent: string | null;
}

const baseURL = `${API_BASE}/groups`;

export const fetch = async () => {
  const url = API_BASE + '/groupsAll';
  return handler(() => axios.get(url));
}

export const fetchData = async (userId: string, parentId: string) => {
  const url = `${baseURL}/${userId}/${parentId}`;
  return handler(() => axios.get(url));
}

export const findById = async (id: string) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.get(url));
}

export const fetchChildren = async (groupId: string) => {
  const url = `${baseURL}/${groupId}/children`;
  return handler(() => axios.get(url));
}

export const update = async (id: string, data: any) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.put(url, data));
}

export const updateSupervisors = async (id: string, supervisors: any) => {
  const url = `${baseURL}/${id}/supervisors`;
  return handler(() => axios.put(url, { supervisors }));
}

export const create = async (data: CreateData) => {
  return handler(() => axios.post(baseURL, data));
}

export const remove = async (id: string) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.delete(url));
}

export const uploadMedia = (groupId: string, form: FormData, listener?: UploadListener) => {
  const url = `${baseURL}/${groupId}/media`;
  let isCompleted = false;
  const config = {
    onUploadProgress: (event) => {
      const percent = Math.round((event.loaded * 100) / event.total);
      listener.onProcess(event, percent);
      if (event.loaded === event.total) {
        // Prevent to call twice
        if (!isCompleted) {
          isCompleted = true;
          listener.onComplete(event);
        }
      }
    }
  };

  return handler(() => axios.put(url, form, listener ? config : {}))
}

export const changeParent = (id: string, parent: string) => {
  const url = `${baseURL}/${id}/parent`;
  return handler(() => axios.put(url, { parent }));
}

export const applyTemplate = (groupId: string, data: any) => {
  const url = `${baseURL}/${groupId}/templates`;
  return handler(() => axios.put(url, data))
}

export const removeMedia = (groupId: string) => {
  const url = `${baseURL}/${groupId}/media`;
  return handler(() => axios.delete(url));
}

export const updatePicturePoint = (id: string, position: MediaPosition) => {
  const url = `${baseURL}/${id}/prefs`;
  return handler(() => axios.put(url, { ...position }));
}

export default {
  fetch,
  fetchData,
  findById,
  fetchChildren,
  update,
  updateSupervisors,
  create,
  remove,
  uploadMedia,
  changeParent,
  applyTemplate,
  removeMedia,
  updatePicturePoint
}
